<template>

  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import "~vue-snotify/styles/material";
  @import "~vue-select/src/scss/vue-select.scss";
  @import 'assets/scss/style';

  @import '~vue-inner-image-zoom/lib/vue-inner-image-zoom.css';


</style>
